export default __webpack_public_path__ + "static/media/linkedin.77c48525.svg";